import { render, staticRenderFns } from "./3DModelsPages.vue?vue&type=template&id=c1ecb0c6&scoped=true&"
import script from "./3DModelsPages.vue?vue&type=script&lang=js&"
export * from "./3DModelsPages.vue?vue&type=script&lang=js&"
import style0 from "./3DModelsPages.vue?vue&type=style&index=0&id=c1ecb0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ecb0c6",
  null
  
)

export default component.exports